import { createStore } from "vuex";
import axios from "axios";
export default createStore({
  state: {
    //apiService: "https://localhost:7078/api",
    apiService: process.env.VUE_APP_API_URL,
    key: process.env.VUE_APP_KEY,
    iv: process.env.VUE_APP_IV,
    //key: "eXSQ6pSMaax9fA8dJLURCWn79jMPskCj",
    //iv: "C7D2E6F1A3B9C4E8",
    userperfil: "",
    token: "",
    version: "1.2.12",
    // Sistema
    MServidor: [],
    // Documentos
    MDocumentos: [],
    MGrupoDocumentos: [],
    MRuta: [],
    MConversion: [],
    // Reporte
    MReporte: [],
    // Parametros
    MDescMoneda: [],
    MDescSucursal: [],
    MTablaSeleccion: [],
    MPermisosTablero: [],
    MCalendario: [],
    MPais: [],
    MZonaDepartamento: [],
    MDpto: [],
    MCity: [],
    MLocalidad: [],
    MUpz: [],
    MCiclo: [],
    MCodigoAyuda: [],
    MMessageError: [],
    MPlantilla: [],
    // Seguridad
    userInfo: [],
    paginainfo: [],
    registromenu: [],
    infoperfil: [],
    infoprocesodato: [],
    infodocumentpodato: [],
    MUsers: [],
    MGroupUsers: [],
    MDirectoryActive: [],
    MSecurityPolitic: [],
    MRol: [],
    MArea: [],
    MCargo: [],
    // Procesos
    MIntefaceData: [],
    MLineas: [],
    MProcesos: [],
    MProcesosDelete: [],
    MDatos: [],
    MTablaNumerico: [],
    MTablaAlfaNumerico: [],
    MCausal: [],
    MConstantes: [],
    // Activos
    MTiposActivos: [],
    MSubTiposActivos: [],
    MFaseColda: [],
    MColor: [],
    MDescProducto: [],
    MServicio: [],
    MREstadoServicio: [],
    MRObservacionServicio: [],
    // Personas
    MRisk: [],
    MNotificacion: [],
  },
  getters: {
    userInfo: (state) => {
      return state.userInfo;
    },
    token: (state) => {
      const tokeninfo = localStorage.getItem("token");
      if (tokeninfo) {
        state.token = tokeninfo;
      }
      return state.token;
    },
    registromenu: (state) => {
      return state.registromenu;
    },
    infoperfil: (state) => {
      return state.infoperfil;
    },
    paginainfo: (state) => {
      return state.paginainfo;
    },
    infoprocesodato: (state) => {
      return state.infoprocesodato;
    },
    infodocumentpodato: (state) => {
      return state.infodocumentpodato;
    },
    // Obtiene los datos del token del usuario
    userperfil: (state) => {
      const usuario = JSON.parse(localStorage.getItem("infouser"));
      const menu = JSON.parse(localStorage.getItem("registromenu"));
      const perfil = JSON.parse(localStorage.getItem("infoperfil"));
      const page = JSON.parse(localStorage.getItem("paginainfo"));
      // Guardamos Informacion Usuario
      if (usuario) {
        state.userInfo = usuario;
      } else {
        state.userInfo = [];
      }
      // Guardamos Informacion Menu
      if (menu) {
        state.registromenu = menu;
      } else {
        state.registromenu = [];
      }
      // Guardamos Informacion Perfil
      if (perfil) {
        state.infoperfil = perfil;
      } else {
        state.infoperfil = [];
      }
      if (page) {
        state.paginainfo = page;
      } else {
        state.paginainfo = [];
      }
      return {
        userInfo: state.userInfo,
        registromenu: state.registromenu,
        infoperfil: state.infoperfil,
        paginainfo: state.paginainfo,
      };
    },
    CerrarSesion(state) {
      localStorage.removeItem("infoperfil");
      localStorage.removeItem("infouser");
      localStorage.removeItem("registromenu");
      localStorage.removeItem("paginainfo");
      this.$router.push("/");
    },
    MServidor: (state) => {
      return state.MServidor;
    },
    MConversion: (state) => {
      return state.MConversion;
    },
    MRuta: (state) => {
      return state.MRuta;
    },
    MDirectoryActive: (state) => {
      return state.MDirectoryActive;
    },
    MSecurityPolitic: (state) => {
      return state.MSecurityPolitic;
    },
    MUsers: (state) => {
      return state.MUsers;
    },
    MGroupUsers: (state) => {
      return state.MGroupUsers;
    },
    MRol: (state) => {
      return state.MRol;
    },
    MArea: (state) => {
      return state.MArea;
    },
    MCargo: (state) => {
      return state.MCargo;
    },
    MDescSucursal: (state) => {
      return state.MDescSucursal;
    },
    MDescMoneda: (state) => {
      return state.MDescMoneda;
    },
    MIntefaceData: (state) => {
      return state.MIntefaceData;
    },
    MLineas: (state) => {
      return state.MLineas;
    },
    MProcesos: (state) => {
      return state.MProcesos;
    },
    MProcesosDelete: (state) => {
      return state.MProcesosDelete;
    },
    MTablaSeleccion: (state) => {
      return state.MTablaSeleccion;
    },
    MDatos: (state) => {
      return state.MDatos;
    },
    MTablaNumerico: (state) => {
      return state.MTablaNumerico;
    },
    MTablaAlfaNumerico: (state) => {
      return state.MTablaAlfaNumerico;
    },
    MCausal: (state) => {
      return state.MCausal;
    },
    MConstantes: (state) => {
      return state.MConstantes;
    },
    MTiposActivos: (state) => {
      return state.MTiposActivos;
    },
    MSubTiposActivos: (state) => {
      return state.MSubTiposActivos;
    },
    MPais: (state) => {
      return state.MPais;
    },
    MZonaDepartamento: (state) => {
      return state.MZonaDepartamento;
    },
    MDpto: (state) => {
      return state.MDpto;
    },
    MCity: (state) => {
      return state.MCity;
    },
    MLocalidad: (state) => {
      return state.MLocalidad;
    },
    MUpz: (state) => {
      return state.MUpz;
    },
    MFaseColda: (state) => {
      return state.MFaseColda;
    },
    MColor: (state) => {
      return state.MColor;
    },
    MGrupoDocumentos: (state) => {
      return state.MGrupoDocumentos;
    },
    MDocumentos: (state) => {
      return state.MDocumentos;
    },
    MCalendario: (state) => {
      return state.MCalendario;
    },
    MRisk: (state) => {
      return state.MRisk;
    },
    MNotificacion: (state) => {
      return state.MNotificacion;
    },
    MDescProducto: (state) => {
      return state.MDescProducto;
    },
    MCiclo: (state) => {
      return state.MCiclo;
    },
    MCodigoAyuda: (state) => {
      return state.MCodigoAyuda;
    },
    MMessageError: (state) => {
      return state.MMessageError;
    },
    MPlantilla: (state) => {
      return state.MPlantilla;
    },
    MServicio: (state) => {
      return state.MServicio;
    },
    MREstadoServicio: (state) => {
      return state.MREstadoServicio;
    },
    MRObservacionServicio: (state) => {
      return state.MRObservacionServicio;
    },
    MReporte: (state) => {
      return state.MReporte;
    },
  },
  mutations: {
    userInfo(state, value) {
      localStorage.removeItem("infouser");
      localStorage.setItem("infouser", JSON.stringify(value));
      state.userInfo = value;
    },
    registromenu(state, value) {
      localStorage.removeItem("registromenu");
      localStorage.setItem("registromenu", JSON.stringify(value));
      state.registromenu = value;
    },
    infoperfil(state, value) {
      localStorage.removeItem("infoperfil");
      localStorage.setItem("infoperfil", JSON.stringify(value));
      state.infoperfil = value;
    },
    paginainfo(state, value) {
      localStorage.removeItem("paginainfo");
      localStorage.setItem("paginainfo", JSON.stringify(value));
      state.paginainfo = value;
    },
    userperfil(state) {},
    infoprocesodato(state, value) {
      state.infoprocesodato = value;
    },
    infodocumentpodato(state, value) {
      state.infodocumentpodato = value;
    },
    // Consulta Usuarios
    async GetUsers(state) {
      axios
        .get(this.state.apiService + "/parametros/CD17")
        .then((response) => {
          state.MUsers = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Group Usuarios
    async GetGroupUsers(state) {
      axios
        .get(this.state.apiService + "/parametros/GetGroupUser")
        .then((response) => {
          state.MGroupUsers = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Roles
    async GetRoles(state) {
      axios
        .get(this.state.apiService + "/parametros/GetRols")
        .then((response) => {
          state.MRol = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Area
    async GetArea(state) {
      axios
        .get(this.state.apiService + "/parametros/GetArea")
        .then((response) => {
          state.MArea = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Cargo
    async GetCargo(state) {
      axios
        .get(this.state.apiService + "/parametros/GetCargo")
        .then((response) => {
          state.MCargo = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Directorio Activo
    async GetDirectoryActive(state) {
      axios
        .get(this.state.apiService + "/parametros/GetDirectotyActive")
        .then((response) => {
          state.MDirectoryActive = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Ruta
    async GetRuta(state) {
      axios
        .get(this.state.apiService + "/parametros/GetRuta")
        .then((response) => {
          state.MRuta = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Conversion
    async GetConversion(state) {
      axios
        .get(this.state.apiService + "/parametros/GetExtensionArchivos")
        .then((response) => {
          state.MConversion = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Servidor
    async GetServidor(state) {
      axios
        .get(this.state.apiService + "/parametros/GetServidor")
        .then((response) => {
          state.MServidor = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Politicas de Seguridad
    async GetSecurityPolitic(state) {
      axios
        .get(this.state.apiService + "/parametros/GetPoliticaSeguridad")
        .then((response) => {
          state.MSecurityPolitic = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Tabla de Selección
    async GetTablaSeleccion(state) {
      axios
        .get(this.state.apiService + "/parametros/TablaSeleccion")
        .then((response) => {
          state.MTablaSeleccion = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Sucursal
    async GetDescSucursal(state) {
      axios
        .get(this.state.apiService + "/parametros/CD18")
        .then((response) => {
          state.MDescSucursal = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Moneda
    async GetDescMoneda(state) {
      axios
        .get(this.state.apiService + "/parametros/GetInfoMoneda")
        .then((response) => {
          state.MDescMoneda = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Interface de datos
    async GetIntefaceData(state) {
      axios
        .get(this.state.apiService + "/parametros/Interface_Datos")
        .then((response) => {
          state.MIntefaceData = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Lineas
    async GetLineas(state) {
      axios
        .get(this.state.apiService + "/parametros/Lineas")
        .then((response) => {
          state.MLineas = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Procesos
    async GetProcesos(state) {
      axios
        .get(this.state.apiService + "/parametros/Procesos")
        .then((response) => {
          state.MProcesos = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Procesos Eliminados
    async GetProcesosDelete(state) {
      axios
        .get(this.state.apiService + "/parametros/ProcesosDelete")
        .then((response) => {
          state.MProcesosDelete = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Datos
    async GetDatos(state) {
      axios
        .get(this.state.apiService + "/parametros/Datos")
        .then((response) => {
          state.MDatos = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Tabla Numerico
    async GetTablaNumerico(state) {
      axios
        .get(this.state.apiService + "/parametros/TablaNumerico")
        .then((response) => {
          state.MTablaNumerico = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Tabla AlfaNumerico
    async GetTablaAlfaNumerico(state) {
      axios
        .get(this.state.apiService + "/parametros/TablaAlfaNumerico")
        .then((response) => {
          state.MTablaAlfaNumerico = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Causales
    async GetCausales(state) {
      axios
        .get(this.state.apiService + "/parametros/Causales")
        .then((response) => {
          state.MCausal = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Constantes
    async GetConstantes(state) {
      axios
        .get(this.state.apiService + "/parametros/Constantes")
        .then((response) => {
          state.MConstantes = response.data;
        });
      //.catch((e) => console.log(e));
    },
    // Consulta Tipo de Activo
    async GetInfoTiposActivos(state) {
      axios
        .get(this.state.apiService + "/parametros/CD2")
        .then((response) => {
          state.MTiposActivos = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Subtipos de activo
    async GetInfoSubTiposActivos(state) {
      axios
        .get(this.state.apiService + "/parametros/CD3")
        .then((response) => {
          state.MSubTiposActivos = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta País
    async GetInfoPais(state) {
      axios
        .get(this.state.apiService + "/parametros/Paises")
        .then((response) => {
          state.MPais = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Zonas Departamentos
    async GetInfoZonaDepartamento(state) {
      axios
        .get(this.state.apiService + "/parametros/CD5")
        .then((response) => {
          state.MZonaDepartamento = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Geografico - Departamento
    async GetDpto(state) {
      axios
        .get(this.state.apiService + "/parametros/Departamento")
        .then((response) => {
          state.MDpto = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Geografico - Ciudad
    async GetLocalidad(state) {
      axios
        .get(this.state.apiService + "/parametros/Localidades")
        .then((response) => {
          state.MLocalidad = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Geografico - Ciudad
    async GetUpz(state) {
      axios
        .get(this.state.apiService + "/parametros/Upz")
        .then((response) => {
          state.MUpz = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Geografico - Ciudad
    async GetCity(state) {
      axios
        .get(this.state.apiService + "/parametros/Ciudades")
        .then((response) => {
          state.MCity = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Fase Colda
    async GetFaseColda(state) {
      axios
        .get(this.state.apiService + "/parametros/CD4")
        .then((response) => {
          state.MFaseColda = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Color
    async GetColor(state) {
      axios
        .get(this.state.apiService + "/parametros/CD5")
        .then((response) => {
          state.MColor = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Grupo Documentos
    async GetGrupoDocumentos(state) {
      axios
        .get(this.state.apiService + "/parametros/GrupoDocumentos")
        .then((response) => {
          state.MGrupoDocumentos = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Grupo Documentos
    async GetDocumentos(state) {
      axios
        .get(this.state.apiService + "/parametros/CD16")
        .then((response) => {
          state.MDocumentos = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Calendario
    async GetCalendario(state) {
      axios
        .get(this.state.apiService + "/parametros/Calendario")
        .then((response) => {
          state.MCalendario = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Riesgos
    async GetRisk(state) {
      axios.get(this.state.apiService + "/parametros/CD10").then((response) => {
        state.MRisk = response.data;
      });
      //.catch((e) => console.log(e));
    },

    // Consulta Notificaciones
    async GetNotificaciones(state) {
      axios
        .get(this.state.apiService + "/parametros/Notificaciones")
        .then((response) => {
          state.MNotificacion = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Producto
    async GetDescProducto(state) {
      axios
        .get(this.state.apiService + "/parametros/CD11")
        .then((response) => {
          state.MDescProducto = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Ciclo
    async GetDescCiclo(state) {
      axios
        .get(this.state.apiService + "/parametros/CD12")
        .then((response) => {
          state.MCiclo = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Codigo Ayuda
    async GetCodigoAyuda(state) {
      axios
        .get(this.state.apiService + "/parametros/CodigoAyuda")
        .then((response) => {
          state.MCodigoAyuda = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Mensaje Error
    async GetMessageError(state) {
      axios
        .get(this.state.apiService + "/parametros/MessageError")
        .then((response) => {
          state.MMessageError = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Plantilla
    async GetPlantilla(state) {
      axios
        .get(this.state.apiService + "/parametros/GetPlantilla")
        .then((response) => {
          state.MPlantilla = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Servicios
    async GetServicios(state) {
      axios
        .get(this.state.apiService + "/parametros/CD13")
        .then((response) => {
          state.MServicio = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Relación Servicios y Estado Soporte
    async GetEstadoServicios(state) {
      axios
        .get(this.state.apiService + "/parametros/CD14")
        .then((response) => {
          state.MREstadoServicio = response.data;
        })
        .catch((e) => console.log(e));
    },
    // Consulta Relación Servicios y Tipo Observación
    async GetObservacionServicios(state) {
      axios
        .get(this.state.apiService + "/parametros/CD15")
        .then((response) => {
          state.MRObservacionServicio = response.data;
        })
        .catch((e) => console.log(e));
    },

    // Consulta Reportes
    async GetReportes(state) {
      axios
        .get(this.state.apiService + "/parametros/Reportes")
        .then((response) => {
          state.MReporte = response.data;
        })
        .catch((e) => console.log(e));
    },
  },
  actions: {},
  modules: {},
});
